/* Opens Shopify's own preferences without changing consent. */
document.addEventListener('click', async event => {
  const trigger = event.target.closest('[data-astra-cookie-preferences]');
  if (!trigger) return;
  const message = trigger.closest('footer').querySelector('[data-astra-cookie-error]');
  message.hidden = true;
  trigger.disabled = true;
  try {
    if (typeof window.privacyBanner?.showPreferences !== 'function') throw new Error('Privacy banner unavailable');
    await window.privacyBanner.showPreferences();
  } catch (_) {
    message.hidden = false;
  } finally {
    trigger.disabled = false;
  }
});
